module.exports = __webpack_public_path__ + "static/media/teltonika-fmu-125-4.f1d73292.png";